import { useEffect, useState } from 'react';

const DURATION_MS = (17 * 60 + 34) * 1000;
const START = Date.now();
const SPOTS_START = 9;
const SPOTS_MIN = 3;
const SPOT_INTERVAL_MS = 45000;
export const TOTAL_SPOTS = 100;

function useNow(intervalMs: number) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(t);
  }, [intervalMs]);
  return now;
}

export function useCountdown() {
  const now = useNow(1000);
  const elapsed = now - START;
  const remainingMs = DURATION_MS - (elapsed % DURATION_MS);
  const totalSeconds = Math.min(Math.ceil(remainingMs / 1000), DURATION_MS / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return { hours, minutes, seconds };
}

export function useSpotsLeft() {
  const now = useNow(5000);
  const spots = Math.max(SPOTS_MIN, SPOTS_START - Math.floor((now - START) / SPOT_INTERVAL_MS));
  return spots;
}
